var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.38737 19.698C1.38224 20.1534 1.49737 20.6098 1.73278 21.0179L4.8824 26.4783C5.34373 27.2781 6.19685 27.7709 7.12016 27.7709H23.8794C24.8027 27.7709 25.6558 27.2781 26.1172 26.4783L29.2668 21.0179C29.5022 20.6098 29.6173 20.1534 29.6122 19.698H1.38737Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1823 27.4184L11.0542 2.94784C11.4477 2.71316 11.9033 2.58325 12.3774 2.58325H18.623C19.5459 2.58325 20.3987 3.07563 20.8602 3.87492L29.2667 18.4353C29.7279 19.2343 29.7281 20.2186 29.2672 21.0177L26.1176 26.4782C25.889 26.8745 25.5641 27.1954 25.1823 27.4184Z",
    fill: "#FBBC04"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9458 2.94785C19.5522 2.71316 19.0967 2.58325 18.6226 2.58325H12.377C11.4541 2.58325 10.6012 3.07563 10.1398 3.87492L1.73331 18.4353C1.27203 19.2343 1.27183 20.2186 1.73278 21.0177L4.8824 26.4782C5.11101 26.8745 5.43582 27.1954 5.8177 27.4184L19.9458 2.94785Z",
    fill: "#34A853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6124 19.698C29.6175 20.1534 29.5024 20.6098 29.267 21.0179L26.1174 26.4783C25.8888 26.8747 25.564 27.1956 25.1821 27.4186L20.7246 19.698H29.6124Z",
    fill: "#EA4335"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9462 2.94785C19.5526 2.71316 19.0971 2.58325 18.623 2.58325H12.3774C11.9033 2.58325 11.4477 2.71316 11.0542 2.94784L15.5002 10.6485L19.9462 2.94785Z",
    fill: "#188038"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.38737 19.698C1.38224 20.1534 1.49737 20.6098 1.73278 21.0179L4.8824 26.4783C5.11101 26.8747 5.43582 27.1956 5.8177 27.4185L10.2752 19.698H1.38737Z",
    fill: "#1967D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrive);
export default __webpack_public_path__ + "static/media/drive.21fdea9db70cb36ada372663d69de25f.svg";
export { ForwardRef as ReactComponent };